<script setup>
import { computed } from "vue";
import DqAvatar from "@/components/shared/DqAvatar.vue";

const props = defineProps({
  rows: {
    type: Array,
    default: () => [],
  },
  loading: {
    type: Boolean,
    default: false,
  },
  total: {
    type: Number,
    default: 0,
  },
  pageSize: {
    type: Number,
    default: 25,
  },
  current: {
    type: Number,
    default: 1,
  },
});

const emit = defineEmits(["change"]);

const columns = [
  {
    sorter: false,
  },
  {
    title: "Name",
    dataIndex: "Name",
    key: "Name",
    sorter: {
      compare: (a, b) => {
        const av = (a.Name || "").toLowerCase();
        const bv = (b.Name || "").toLowerCase();
        return av > bv ? -1 : bv > av ? 1 : 0;
      },
    },
  },
  {
    title: "Date",
    dataIndex: "Date",
    key: "Date",
    sorter: {
      compare: (a, b) => {
        const av = (a.Date || "").toLowerCase();
        const bv = (b.Date || "").toLowerCase();
        return av > bv ? -1 : bv > av ? 1 : 0;
      },
    },
  },
  {
    title: "Department",
    dataIndex: "Department",
    key: "Department",
    sorter: {
      compare: (a, b) => {
        const av = (a.Department || "").toLowerCase();
        const bv = (b.Department || "").toLowerCase();
        return av > bv ? -1 : bv > av ? 1 : 0;
      },
    },
  },
  {
    title: "Status",
    dataIndex: "Status",
    key: "Status",
    sorter: {
      compare: (a, b) => {
        const av = (a.Status || "").toLowerCase();
        const bv = (b.Status || "").toLowerCase();
        return av > bv ? -1 : bv > av ? 1 : 0;
      },
    },
  },
];

const rowSelection = {
  onChange: () => {},
  onSelect: () => {},
  onSelectAll: () => {},
};

// map API rows -> table rows
const dataSource = computed(() =>
  (props.rows || []).map((r) => ({
    key: r.id,
    Image: r.employee?.photo_url || r.employee?.avatar_url || "",
    Name: r.employee?.name || "-",
    Role: r.employee?.designation || "",
    Date: r.date,
    Department: r.employee?.department || "",
    Status: r.status,
  }))
);

function handleChange(pagination, filters, sorter) {
  emit("change", pagination, filters, sorter);
}
</script>

<template>
  <a-table
    class="table datatable thead-light dq-report-table"
    :columns="columns"
    :data-source="dataSource"
    :row-selection="rowSelection"
    :pagination="{
      total,
      pageSize,
      current,
      showSizeChanger: true,
      showTotal: (t) => `Total ${t} items`,
    }"
    :loading="loading"
    @change="handleChange"
    row-key="key"
  >
    <template #bodyCell="{ column, record }">
      <template v-if="column.key === 'Name'">
        <div class="d-flex align-items-center">
          <a
            href="javascript:void(0);"
            data-bs-toggle="modal"
            data-bs-target="#view_details"
          >
            <DqAvatar
              :src="record.Image"
              :name="record.Name"
              size-class="avatar-md"
              shape-class="rounded-circle"
            />
          </a>
          <div class="ms-2">
            <p class="text-dark mb-0">
              <a
                href="javascript:void(0);"
                data-bs-toggle="modal"
                data-bs-target="#view_details"
                >{{ record.Name }}</a
              >
            </p>
            <span class="fs-12">{{ record.Role }}</span>
          </div>
        </div>
      </template>

      <template v-if="column.key === 'Status'">
        <span
          class="d-inline-flex align-items-center badge-xs"
          :class="[
            'badge',
            record.Status === 'Present'
              ? 'badge-soft-success'
              : 'badge-soft-danger',
          ]"
        >
          <i class="ti ti-point-filled me-1"></i>{{ record.Status }}
        </span>
      </template>
    </template>
  </a-table>
</template>

<style scoped>
@media (max-width: 767.98px) {
  :deep(.dq-report-table .ant-table) {
    min-width: 760px;
  }

  :deep(.dq-report-table .ant-table-cell) {
    vertical-align: top;
    white-space: normal;
  }
}
</style>
